import { ROUTES } from "Constants/AllRoutes";
import { LINKEDIN_PAGE } from "Constants/common";
import { Linkedin, Instagram, Twitter, Youtube } from "lucide-react";

export function Footer() {
  const quickLinks = [
    { name: "Our Team", href: ROUTES.OUR_TEAM },
    { name: "Blog", href: ROUTES.BLOG },
    { name: "Contact", href: "mailto:admin@onegrad.ai" },
  ];

  const legalLinks = [
    { name: "Terms", href: "#terms" },
    { name: "Privacy", href: "#privacy" },
  ];

  const socialLinks = [
    { name: "LinkedIn", icon: Linkedin, href: LINKEDIN_PAGE },
    { name: "Instagram", icon: Instagram, href: "#instagram" },
    { name: "Twitter", icon: Twitter, href: "#twitter" },
    { name: "YouTube", icon: Youtube, href: "#youtube" },
  ];

  return (
    <footer className="bg-card border-t border-border text-base w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2 space-y-4 text-left">
            <div className="text-lg font-bold text-left">
              <img
                src={
                  "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
                }
                alt="logo"
                className="navbar-main-logo"
              />
            </div>
            <p className="text-muted-foreground max-w-md">
              Connecting verified mentors with students for personalized
              guidance and career success.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4 text-left">
            <h3 className="font-semibold text-card-foreground text-base">
              Quick Links
            </h3>
            <div className="space-y-2">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-muted-foreground hover:text-primary transition-colors text-base"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Social and Legal */}
          <div className="space-y-4 text-left">
            <h3 className="font-semibold text-card-foreground">Connect</h3>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    <IconComponent className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <div className="flex space-x-6">
            {legalLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-base text-muted-foreground hover:text-primary transition-colors"
              >
                {link.name}
              </a>
            ))}
          </div>

          <p className="text-base text-muted-foreground">
            © {new Date().getFullYear()} OneGrad. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
